<template>
  <div
    class="plan-detail"
    v-loading="checkOutLoading">
    <template v-if="!payEnd">
      <div
        class="plan-con"
        :style="{background: plan.background}">
        <div class="title-wrap">
          <div class="title">{{ plan.fakePlanName }}</div>
          <div
            class="reselect"
            @click="reselectPlan">Reselect Plan</div>
        </div>
        <div
          class="expiration"
          v-if="plan.status == 5">Expiration date: sub already expired</div>
        <div
          class="expiration"
          v-else>Expiration date: {{expireTime | transDateAndTime(3)}}</div>
        <div
          class="manage-pay"
          @click="payMent">
          <div>Manage Payment</div>
          <div class="icon"><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <div class="time-info">
        <div class="remain">Time Remaining</div>
        <div class="time-change">
          <div
            class="time-format"
            v-if="plan.status == 5">{{handleQuantity(0)}}</div>
          <div
            class="time-format"
            v-else>{{handleQuantity(planQuantitly)}}</div>
          <span class="el-icon-right"></span>
          <div class="time-format new-time">{{handleQuantity(addPlanQuantity)}}</div>
        </div>
      </div>
      <div class="add-wrap">
        <div class="add-title">
          <span>Hours added</span>
          <span class="valid">Hours are valid for up to {{validDate}} months</span>
        </div>
        <div class="title-input">
          <el-input
            v-model="inputAddHours"
            type="number"
            @input="handleInput"
            placeholder="Please input number no more than 4320"></el-input>
          <div class="charge-wrap">
            <p>Live source: {{ liveSource }}</p>
            <p>Output: {{ output }}</p>
          </div>
        </div>
      </div>
      <div class="pay-footer">
        <div class="price">${{ this.addPlanPrice }}</div>
        <div class="confirm">
          <el-button
            @click="handleCheckOut"
            :disabled="!Number(inputAddHours)">Buy</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <img
        class="all-right"
        src="@/assets/svg/allright.svg"
        alt="">
      <div class="pay-start">PAYMENT COMPLETE</div>
      <div class="pay-info">
        Thank you, your payment has been successful.
        You can start use it now.
      </div>
      <div class="trial-footer">
        <div
          class="close"
          @click="handleCloseIframe">
          Close
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { queryPrice, handleNewSub, handlecustomerPortal, paymentMethodInfoByIntentId } from '@/common/checkuser.js'
import Helper from '@/common/helper.js'
import { Message } from 'element-ui'
export default {
  props: {
    plan: Object
  },
  inject: ['emailid', 'loadData', 'paySuccess'],
  data () {
    return {
      inputAddHours: null,
      lastInputHours: null,
      addPlanPrice: 0,
      addPlanQuantity: 0,
      HandleQueryPrice: null,
      checkOutLoading: false,
      payEnd: false,
      liveSource: 0,
      output: 0
    }
  },
  created () {
    this.HandleQueryPrice = Helper.debounce(this.handleQueryPrice)
    this.HandleQueryPrice()
    this.handleChargeItems()
  },
  methods: {
    handleChargeItems () {
      const chargeItems = this.plan.chargeItems
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          this.liveSource = i.quantity
        } else if (i.addonId == 'producer-additional-output') {
          this.output = i.quantity
        }
      })
    },
    // 关闭弹窗
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    // 重新选择plan
    reselectPlan () {
      this.$emit('reselectPlan', false)
    },
    // 输入时间
    handleInput (value) {
      if (!value) return this.HandleQueryPrice()
      const input = Number(value)
      if (input > 4320) {
        this.inputAddHours = this.lastInputHours
        Message.warning('Please input the hours no more than 4320')
      } else if (!Number.isInteger(input) || input < 0) {
        // 判断整数
        this.inputAddHours = this.lastInputHours
      } else {
        this.lastInputHours = input
        this.HandleQueryPrice()
      }
    },
    handleAddOn (chargeItems) {
      let InputNumber = {}
      let TimeCredit = {}
      let Output = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          InputNumber = i
        } else if (i.addonId == 'producer-time-credit') {
          TimeCredit = i
        } else if (i.addonId == 'producer-additional-output') {
          Output = i
        }
      })

      return { InputNumber, TimeCredit, Output }
    },
    // 查询价格
    handleQueryPrice () {
      const planchargeItems = this.plan.chargeItems
      const { InputNumber, TimeCredit, Output } = this.handleAddOn(planchargeItems)
      const quantity = Number(this.inputAddHours)
      const chargeItems = {
        [InputNumber.addonId]: InputNumber.quantity,
        [TimeCredit.addonId]: quantity,
        [Output.addonId]: Output.quantity
      }
      let params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems)
      }

      queryPrice(params).then(({ data }) => {
        if (data.previewCustomSubscription) {
          this.addPlanPrice = data.previewCustomSubscription.price / 100
          this.addPlanQuantity = data.previewCustomSubscription.quantity
        }
      })
    },
    // 点击 buy
    handleCheckOut () {
      this.checkOutLoading = true
      const planchargeItems = this.plan.chargeItems
      const { InputNumber, TimeCredit, Output } = this.handleAddOn(planchargeItems)
      const quantity = Number(this.inputAddHours)
      const chargeItems = {
        [InputNumber.addonId]: InputNumber.quantity,
        [TimeCredit.addonId]: quantity,
        [Output.addonId]: Output.quantity
      }
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.plan.planId,
        chargeItems: JSON.stringify(chargeItems),
        description: `${this.plan.planName} ${this.emailid} checkoutSubscription`
      }
      handleNewSub(params, this).then((res) => {
        this.checkOutLoading = false
        if (res.checkoutSubscription && res.checkoutSubscription.paymentIntentId) {
          this.paymentInfo(res.checkoutSubscription.paymentIntentId)
        } else {
          this.payEnd = true
        }
        // this.loadData()
      }).catch(err => {
        Message.error({
          message: err.info,
          duration: 5000
        })
        this.checkOutLoading = false
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    paymentInfo (paymentIntentId) {
      paymentMethodInfoByIntentId({ paymentIntentId }).then(res => {
        console.log(res)
        if (res.data.paymentMethodInfoByIntentId) {
          const paymentMethodInfoByIntentId = res.data.paymentMethodInfoByIntentId
          const info = {
            'PAYMENT TYPE': paymentMethodInfoByIntentId.card.brand,
            COUNTRY: paymentMethodInfoByIntentId.card.country,
            'PAYMENT METHOD': '**** **** ****' + paymentMethodInfoByIntentId.card.last4,
            'PAYMENT DATE': Helper.timestampToDate(new Date().getTime(), 'MM/DD/YYYY')
          }
          this.paySuccess(info)
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    },
    // 打开 管理卡的窗口
    payMent () {
      const params = {
        customerId: this.emailid,
        product: 'Producer'
      }
      handlecustomerPortal(params)
    }
  },
  computed: {
    planQuantitly () {
      const chargeItems = this.plan.chargeItems
      const chargeItem = chargeItems.find(i => i.addonId == 'producer-time-credit')
      return chargeItem.quantity
    },
    ppExpireTime () {
      return this.$store.state.initMsg.ppExpireTime
    },
    expireTime () {
      const time = Number(this.plan.paymentTime) + this.ppExpireTime
      return time
    },
    // 转化为 months
    validDate () {
      return Math.floor(this.ppExpireTime / 1000 / 60 / 60 / 24 / 30)
    }
  },
  filters: {
    transDateAndTime (value, type) {
      value = Number(value)
      if (!value || value >= 9999999999999) return '---'
      let oDate = new Date(value)
      let oYear = oDate.getFullYear()
      let oMonth = oDate.getMonth() + 1
      let oDay = oDate.getDate()
      let oHour = oDate.getHours()
      let oMin = oDate.getMinutes()
      let oSen = oDate.getSeconds()
      let oMil = oDate.getMilliseconds()
      oHour = oHour <= 9 ? '0' + oHour : oHour
      oMin = oMin <= 9 ? '0' + oMin : oMin
      oSen = oSen <= 9 ? '0' + oSen : oSen
      oMil = oMil <= 99 ? (oMil = oMil <= 9 ? '00' + oMil : '0' + oMil) : oMil
      let oTime = ''
      if (type == 1) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = oMonth + '-' + oDay + ' ' + oHour + ':' + oMin
      } else if (type == 2) {
        oTime = oHour + ':' + oMin + ':' + oSen + ':' + oMil
      } else if (type == 3) {
        oTime = oYear + '/' + oMonth + '/' + oDay
      } else if (type == 4) {
        oTime = oYear + '-' + oMonth + '-' + oDay + ' ' + oHour + ':' + oMin + ':' + oSen
      } else if (type == 5) {
        oMonth = oMonth <= 9 ? '0' + oMonth : oMonth
        oDay = oDay <= 9 ? '0' + oDay : oDay
        oTime = '' + oYear + oMonth + oDay + oHour + oMin + oSen + oMil
      } else if (type == 6) {
        oTime = oHour + ':' + oMin + ':' + oSen
      } else {
        oTime = oYear + '/' + oMonth + '/' + oDay + ' ' + oHour + ':' + oMin
      }
      return oTime
    }
  }
}
</script>

<style lang="less" scoped>
  .plan-detail {
    width: 408px;
    position: relative;
    min-height: 460px;
    .plan-con {
      background: linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%);
      height: 134px;
      padding:30px 0 20px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      .title-wrap {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
      }
      .title {
        font-weight: 700;
        font-size: 36px;
        line-height: 36px;
        color: #444444;
      }
      .reselect {
        color: #ffffff;
        font-size: 14px;
        border: 1px solid;
        padding: 5px 8px;
        border-radius: 8px;
        cursor: pointer;
      }
      .expiration {
        text-align: left;
        margin: 40px 0 0 20px;
        color: #EC5050;
      }
      .manage-pay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        // width: 100%;
        display: flex;
        height: 42px;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        color: #ffffff;
        cursor: pointer;
      }
      .choose {
        padding: 0 30px;
        word-break: break-word;
        text-align: left;
        font-size: 16px;
        color: #EC5050;
      }
    }

    .time-info {
      // margin: ;
      .remain {
        margin: 20px 0 10px;
        font-size: 20px;
        line-height: 23px;
        color: #585B5D;
      }
      .time-change {
        display: flex;
        justify-content: center;
        align-items: center;
        .el-icon-right {
          font-weight: 900;
          font-size: 18px;
          color: var(--dialog-arrow-color);
          margin: 0 15px;
        }
        .time-format {
          font-size: 16px;
          line-height: 19px;
          color: var(--dialog-text-color);
        }
        .new-time {
          color: #5DC045;
        }
      }
    }

    ::v-deep .title-input {
      .el-input__inner {

      }
      input::-webkit-inner-spin-button {
        display: none;
      }
    }
    .add-wrap {
      text-align: left;
      margin-top: 20px;
      .add-title {
        font-weight: 500;
        line-height: 20px;
        color: var(--dialog-text-color);
        .valid {
          font-size: 12px;
          line-height: 14px;
          color: var(--dialog-text-info-color);
          margin-left: 15px;
        }
      }
      .charge-wrap {
        margin: 5px 0;
        color: var(--dialog-text-info-color);
      }
    }

    .pay-footer {
      display: flex;
      padding: 0 20px;
      margin-top: 40px;
      justify-content: space-between;
      border-top: 2px solid var(--dialog-border-color);
      padding-top: 20px;
      .confirm {
        .el-button {
          width: 80px;
          height: 32px;
          border: none;
          background: #33AB4F;
          color: #FFFFFF;
        }
        .el-button.is-disabled {
          background: #8BC194;
          color: #F0F0F0;
        }
      }
      .price {
        color: #33AB4F;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }
</style>
